import { date } from 'quasar'
import { get } from 'lodash'
import { parseDateTime } from 'src/utils/date'
import { subscription } from 'src/config'

class Team {
  constructor (data) {
    data.settings = data.settings.data
    data.settings.default_address = get(data, 'settings.default_address.data', null)
    data.settings.default_email_address = get(data, 'settings.default_email_address.data', null)
    data.settings.default_phone_number = get(data, 'settings.default_phone_number.data', null)
    data.settings.default_bank_details = get(data, 'settings.default_bank_details.data', null)
    data.managers = get(data, 'managers', [])
    data.members = get(data, 'members.data', [])
    data.invites = get(data, 'open_invites.data', [])
    data.subscription = get(data, 'subscription.data', null)

    delete data.open_invites

    Object.assign(this, data)
  }

  hasActiveSubscription () {
    return this.hasSubscription() && this.subscription.ends_at === null
  }

  onGracePeriod () {
    return this.hasSubscription() && this.subscription.ends_at != null &&
      parseDateTime(this.subscription.ends_at.date).getTime() > (new Date()).getTime()
  }

  onTrial () {
    return !this.subscribed && this.on_trial
  }

  isSubscribedOrOnTrial () {
    return this.subscribed || this.on_trial
  }

  subscriptionExpired () {
    return !this.subscribed && !this.on_trial
  }

  trialExpiring () {
    return this.onTrial() &&
      parseDateTime(this.trial_ends_at.date).getTime() <= date.addToDate(Date.now(), { days: subscription.trial_expiring_hint }).getTime()
  }

  subscriptionExpiring () {
    return this.onGracePeriod() &&
      parseDateTime(this.subscription.ends_at.date).getTime() <= date.addToDate(Date.now(), { days: subscription.subscription_expiring_hint }).getTime()
  }

  trialExpirationDate () {
    return date.formatDate(parseDateTime(this.trial_ends_at.date), 'D. MMMM')
  }

  subscriptionExpirationDate () {
    return date.formatDate(parseDateTime(this.subscription.ends_at.date), 'D. MMMM')
  }

  hasSubscription () {
    return this.subscribed && this.subscription != null
  }

  wasSubscribed () {
    return this.subscription != null
  }

  isSubscribedToStudentPlan () {
    return this.hasSubscription() && this.subscription.stripe_plan.startsWith('student')
  }
}

export default Team
